

import {  makeStyles } from "@material-ui/core";
import { CryptoState } from '../CryptoContext';
import { CircularProgress } from "@material-ui/core";
import React,{lazy,Suspense } from "react";

const CoinPage = lazy(() => import("../Pages/CoinPage"));
const CoinInfo = lazy(() => import("./CoinInfo"));

function CoinDetails() {

    const { coin_data} = CryptoState();
  
      const useStyles = makeStyles((theme) => ({
        container: {
          display: "flex",
          [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "center",
          },
        },
      }));
    
      const classes = useStyles();
  return (
    <div>
     <Suspense fallback={<div style={{display:'flex', justifyContent: 'center', textAlign: 'center', marginTop: '30vh' }}> <CircularProgress style={{ color: "gold"}} size={250} thickness={1} /></div>} >

         <div className={classes.container}>
        <CoinPage/>
        <CoinInfo />
        </div>
        </Suspense>
    </div>
  )
}

export default CoinDetails